export function OutlineCloneIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.9954 7.53122V15.4417C19.9954 16.3009 19.2994 16.9969 18.4354 16.9969H10.5633C9.69934 16.9969 8.99854 16.3009 8.99854 15.4417V4.55521C8.99854 3.696 9.69934 3 10.5633 3H15.4402C15.853 3 16.2514 3.1632 16.5442 3.456L19.5394 6.43201C19.8322 6.72482 19.9954 7.11842 19.9954 7.53122Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
      <path
        d="M14.4993 8.00195V13.0036"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.9954 10.502H11.9985"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9968 16.9975V19.004C15.9968 20.108 15.104 21.0008 14 21.0008H6.99681C5.8928 21.0008 5 20.108 5 19.004V9.00071C5 7.89671 5.8928 7.00391 6.99681 7.00391H8.99842V15.4423C8.99842 16.3015 9.69922 16.9975 10.5632 16.9975H15.9968Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
    </svg>
  );
}
